import { render, staticRenderFns } from "./footer-moebel.vue?vue&type=template&id=6c63080d"
import script from "./footer-moebel.vue?vue&type=script&lang=js"
export * from "./footer-moebel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports